import { createSvgIconComponent } from "../";

export const IconLocationPin = createSvgIconComponent({
  fillRule: "evenodd",
  clipRule: "evenodd",
  path: "M5 12s5-4.292 5-7.034C10 2.223 7.761 0 5 0S0 2.223 0 4.966C0 7.708 5 12 5 12zm0-4.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
  viewBox: "0 0 10 12",
});
